module.exports = __webpack_public_path__ + "static/media/TotalMeses.75ca64d2.svg";